export default __webpack_public_path__ + "static/media/printdefault.7a7b43f1.svg";